"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useRef, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay, EffectFade, EffectCards } from "swiper/modules";
import type { Swiper as SwiperType } from "swiper/types";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/effect-fade";
import "swiper/css/effect-cards";

// import Image from "next/image";
// import AgaBanner from '../../../public/banner.jpg';
// import AgaBannerMob from '../../../public/bannermob.jpg';

import { ArrowRight, ArrowLeft } from "lucide-react";
interface SwiperSliderProps<T> {
  maxItem?: string;
  minItem?: string;
  midItem?: string;
  className?: string;
  type?: "fullscreen" | string;
  autoplay?: boolean;
  loop?: boolean;
  autoplayDelay?: number;
  data: T[];
  renderItem: (item: T, index: number) => React.ReactNode;
}
export function CSlider(t0) {
  const $ = _c(41);
  const {
    data,
    renderItem,
    className: t1,
    maxItem,
    minItem: t2,
    midItem: t3,
    type,
    autoplay: t4,
    loop: t5,
    autoplayDelay: t6
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const minItem = t2 === undefined ? "" : t2;
  const midItem = t3 === undefined ? "" : t3;
  const autoplay = t4 === undefined ? false : t4;
  const loop = t5 === undefined ? false : t5;
  const autoplayDelay = t6 === undefined ? 4000 : t6;
  const swiperRef = useRef(null);
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const isFullscreen = type === "fullscreen" ? "fullscreen" : type === "fullscreengrab" ? "fullscreengrab" : "";
  let t7;
  let t8;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => {
      const swiper = swiperRef.current;
      if (swiper && swiper.params.navigation && typeof swiper.params.navigation !== "boolean" && prevRef.current && nextRef.current) {
        swiper.params.navigation.prevEl = prevRef.current;
        swiper.params.navigation.nextEl = nextRef.current;
        swiper.navigation?.init();
        swiper.navigation?.update();
      }
    };
    t8 = [];
    $[0] = t7;
    $[1] = t8;
  } else {
    t7 = $[0];
    t8 = $[1];
  }
  useEffect(t7, t8);
  if (!data || data.length === 0) {
    return null;
  }
  let t9;
  if ($[2] !== autoplay) {
    t9 = autoplay ? [Autoplay] : [];
    $[2] = autoplay;
    $[3] = t9;
  } else {
    t9 = $[3];
  }
  let t10;
  let t11;
  if ($[4] !== isFullscreen) {
    t10 = isFullscreen === "fullscreen" ? [EffectFade] : [];
    t11 = isFullscreen === "fullscreengrab" ? [EffectCards] : [];
    $[4] = isFullscreen;
    $[5] = t10;
    $[6] = t11;
  } else {
    t10 = $[5];
    t11 = $[6];
  }
  let t12;
  if ($[7] !== t10 || $[8] !== t11 || $[9] !== t9) {
    t12 = [Navigation, ...t9, ...t10, ...t11];
    $[7] = t10;
    $[8] = t11;
    $[9] = t9;
    $[10] = t12;
  } else {
    t12 = $[10];
  }
  const t13 = loop ? loop : false;
  let t14;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = {
      perSlideRotate: 0,
      perSlideOffset: 7
    };
    $[11] = t14;
  } else {
    t14 = $[11];
  }
  const t15 = isFullscreen === "fullscreen" ? "fade" : isFullscreen === "fullscreengrab" ? "cards" : undefined;
  const t16 = isFullscreen === "fullscreengrab" ? true : false;
  const t17 = isFullscreen ? 1 : maxItem ? Number(maxItem) : 8;
  let t18;
  if ($[12] !== autoplay || $[13] !== autoplayDelay) {
    t18 = autoplay ? {
      delay: autoplayDelay
    } : false;
    $[12] = autoplay;
    $[13] = autoplayDelay;
    $[14] = t18;
  } else {
    t18 = $[14];
  }
  let t19;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = swiper_0 => swiperRef.current = swiper_0;
    $[15] = t19;
  } else {
    t19 = $[15];
  }
  let t20;
  if ($[16] !== isFullscreen || $[17] !== maxItem || $[18] !== midItem || $[19] !== minItem) {
    t20 = isFullscreen ? {
      0: {
        slidesPerView: 1
      }
    } : {
      120: {
        slidesPerView: 1
      },
      565: {
        slidesPerView: minItem ? Number(minItem) : 2
      },
      1000: {
        slidesPerView: minItem ? Number(minItem) : 5
      },
      1100: {
        slidesPerView: midItem ? Number(midItem) : 6
      },
      1600: {
        slidesPerView: midItem ? Number(midItem) : 7
      },
      1800: {
        slidesPerView: maxItem ? Number(maxItem) : 8
      }
    };
    $[16] = isFullscreen;
    $[17] = maxItem;
    $[18] = midItem;
    $[19] = minItem;
    $[20] = t20;
  } else {
    t20 = $[20];
  }
  const t21 = `${isFullscreen ? "w-full h-full" : "!pb-1 !pt-3"} ${className}`;
  let t22;
  if ($[21] !== data || $[22] !== renderItem) {
    let t23;
    if ($[24] !== renderItem) {
      t23 = (item, index) => <SwiperSlide key={index}>{renderItem(item, index)}</SwiperSlide>;
      $[24] = renderItem;
      $[25] = t23;
    } else {
      t23 = $[25];
    }
    t22 = data.map(t23);
    $[21] = data;
    $[22] = renderItem;
    $[23] = t22;
  } else {
    t22 = $[23];
  }
  let t23;
  if ($[26] !== t12 || $[27] !== t13 || $[28] !== t15 || $[29] !== t16 || $[30] !== t17 || $[31] !== t18 || $[32] !== t20 || $[33] !== t21 || $[34] !== t22) {
    t23 = <Swiper modules={t12} loop={t13} cardsEffect={t14} spaceBetween={20} effect={t15} grabCursor={t16} slidesPerView={t17} autoplay={t18} onSwiper={t19} breakpoints={t20} className={t21}>{t22}</Swiper>;
    $[26] = t12;
    $[27] = t13;
    $[28] = t15;
    $[29] = t16;
    $[30] = t17;
    $[31] = t18;
    $[32] = t20;
    $[33] = t21;
    $[34] = t22;
    $[35] = t23;
  } else {
    t23 = $[35];
  }
  let t24;
  if ($[36] !== isFullscreen) {
    t24 = isFullscreen === "fullscreen" || isFullscreen === "fullscreengrab" ? <div className="flex items-center absolute top-14 left-10 z-40"><div ref={nextRef} className="relative top-1/2 z-10 flex h-8 w-8 cursor-pointer items-center justify-center rounded-full bg-white/90 text-gray-900 shadow-md transition hover:bg-gray-100  dark:bg-white/10 dark:text-white dark:hover:bg-white/20"><ArrowRight size={16} strokeWidth={1.5} /></div><div ref={prevRef} className="relative ms-3 top-1/2 z-10 flex h-8 w-8 cursor-pointer items-center justify-center rounded-full bg-white/90 text-gray-900 shadow-md transition hover:bg-gray-100  dark:bg-white/10 dark:text-white dark:hover:bg-white/20"><ArrowLeft size={16} strokeWidth={1.5} /></div></div> : <><div ref={prevRef} className="absolute right-0 sm:-right-6 top-1/2 z-10 -mt-6 flex h-8 w-8 cursor-pointer items-center justify-center rounded-full border border-white/30 bg-white/90 text-gray-900 shadow-md transition hover:bg-gray-100 dark:border-white dark:bg-white/10 dark:text-white dark:hover:bg-white/20"><ArrowRight size={16} strokeWidth={1.5} /></div><div ref={nextRef} className="absolute left-0 sm:-left-6 top-1/2 z-10 -mt-6 flex h-8 w-8 cursor-pointer items-center justify-center rounded-full border border-white/30 bg-white/90 text-gray-900 shadow-md transition hover:bg-gray-100 dark:border-white dark:bg-white/10 dark:text-white dark:hover:bg-white/20"><ArrowLeft size={16} strokeWidth={1.5} /></div></>;
    $[36] = isFullscreen;
    $[37] = t24;
  } else {
    t24 = $[37];
  }
  let t25;
  if ($[38] !== t23 || $[39] !== t24) {
    t25 = <div className="relative">{t23}{t24}</div>;
    $[38] = t23;
    $[39] = t24;
    $[40] = t25;
  } else {
    t25 = $[40];
  }
  return t25;
}